/**
 * @license Angular v21.2.7
 * (c) 2010-2026 Google LLC. https://angular.dev/
 * License: MIT
 */

import * as i0 from '@angular/core';
import { InjectionToken, Injectable } from '@angular/core';
const PRECOMMIT_HANDLER_SUPPORTED = new InjectionToken('', {
  factory: () => {
    return typeof window !== 'undefined' && typeof window.NavigationPrecommitController !== 'undefined';
  }
});
class PlatformNavigation {
  static ɵfac = function PlatformNavigation_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PlatformNavigation)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PlatformNavigation,
    factory: () => (() => window.navigation)(),
    providedIn: 'platform'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlatformNavigation, [{
    type: Injectable,
    args: [{
      providedIn: 'platform',
      useFactory: () => window.navigation
    }]
  }], null, null);
})();
export { PRECOMMIT_HANDLER_SUPPORTED, PlatformNavigation };
